import { createFileRoute } from "@tanstack/react-router";
import { ResultsView } from "../app/views/results/resultsView";

export const Route = createFileRoute("/results")({
  component: ResultsView,
});
